import { TiptapLink } from 'novel';
import { Plugin, PluginKey, TextSelection } from 'prosemirror-state';
import { EditorView } from 'prosemirror-view';

// Custom link extension that opens link dialog on click
export const CustomLink = TiptapLink.extend({
  addOptions() {
    return {
      ...this.parent?.(),
      openOnClick: false,
      HTMLAttributes: {
        class: 'text-primary underline cursor-pointer',
      },
    };
  },

  addProseMirrorPlugins() {
    const parent = this.parent?.() || [];
    const editor = this.editor;
    
    return [
      ...parent,
      new Plugin({
        key: new PluginKey('linkClickHandler'),
        props: {
          handleDOMEvents: {
            click: (view: EditorView, event: Event) => {
              const target = event.target as HTMLElement;

              // Check if clicked element is a link or inside a link
              const linkElement = target.closest('a');

              if (linkElement) {
                event.preventDefault();
                event.stopPropagation();
                
                // CRITICAL: Manually move the selection to the clicked link
                // This is necessary because event.preventDefault() stops the editor from
                // automatically moving the selection, which causes stale data in the link dialog.
                try {
                  const pos = view.posAtDOM(linkElement, 0);
                  if (pos >= 0) {
                    if (editor) {
                      // Use TipTap's built-in command to precisely select the entire mark range
                      // We select pos + 1 to ensure we are truly "inside" the mark before extending
                      editor.chain().setTextSelection(pos + 1).extendMarkRange('link').run();
                    } else {
                      // Fallback to basic selection
                      const { tr } = view.state;
                      // Create a selection at the link position (slightly inside)
                      const selection = TextSelection.create(view.state.doc, pos + 1);
                      view.dispatch(tr.setSelection(selection));
                    }
                  }
                } catch (e) {
                  console.error('[CustomLink] Error setting selection:', e);
                }

                // Dispatch custom event to open link dialog
                const customEvent = new CustomEvent('open-link-dialog');
                document.dispatchEvent(customEvent);

                return true;
              }
              
              return false;
            },
          },
        },
      }),
    ];
  },
});
